import { useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { fetchWithAuth, getCSRFToken } from "../auth";
import { Button, Message } from "semantic-ui-react";
import Editor from 'react-simple-wysiwyg';
import { LoadingWrapper } from "../common";
import './Checklist.css'

export const Checklist = () => {
    const { id } = useParams()
    const [isEditing, setIsEditing] = useState(false)
    const [html, setHtml] = useState('');
    const [error, setError] = useState('');
    const [hasChanged, setHasChanged] = useState(false)
    const [loaded, setLoaded] = useState(false)

    async function getChecklist() {
        setError('')
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + `devicesubtypes/${id}/checklist/`, {
            headers: { 'X-CSRFToken': getCSRFToken() },
            credentials: 'include'
        })
        if (!resp.ok) {
            setError("An error occurred.")
            return;
        }
        const respJson = await resp.json()
        if (!respJson['content'] || !('html' in respJson['content'])) {
            setError("An error occurred. You might have to recreate this subtype.")
            return
        }
        setHtml(respJson['content']['html'])
        setLoaded(true)
    }

    const updateChecklist = async () => {
        setError('')
        const response = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + `/devicesubtypes/${id}/checklist/`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken()
            },
            body: JSON.stringify({
                content: { html: html }
            }),
        });
        if(!response.ok) {
            setError("Something went wrong.")
        }
    }

    useEffect(() => {
        getChecklist()
    }, [])

    function onChange(e) {
        setHtml(e.target.value);
        setHasChanged(true)
    }

    useEffect(() => {
        if (!isEditing && hasChanged) {
            updateChecklist()
            setHasChanged(false)
        }
    }, [isEditing])

    return (
        <LoadingWrapper loading={!loaded} text="Loading checklist">
            <div className="outer-wrapper">
                {error ? <Message style={{ width: "fit-content" }} negative>{error}</Message> : <div className="inner-wrapper">
                    {isEditing ?
                        <Editor value={html} onChange={onChange} /> :
                        <div
                            style={{ textWrap: "wrap", margin: "1rem" }}
                            dangerouslySetInnerHTML={{ __html: html }}
                        />}
                    <Button onClick={() => setIsEditing(!isEditing)}
                        style={{ margin: "1rem", width: "fit-content" }}>
                        {isEditing ? "Save" : "Edit"}
                    </Button>
                </div>}
            </div>
        </LoadingWrapper>
    );

}
